import React from "react";
import { motion } from "framer-motion";
import ResumeCard from "./ResumeCard";

const Achievement = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.5 } }}
      className="w-full flex flex-col lgl:flex-row gap-10 lgl:gap-10"
    >
      <div className="w-full lg:w-1/2">
        <div className="py-6 lgl:py-12 font-titleFont flex flex-col gap-4">
          <p className="text-sm font-bold text-designColor tracking-[4px]">2022 - 2025</p>
          <h2 className="text-3xl md:text-4xl font-bold">Major Project Achievements</h2>
        </div>
        <div className="mt-6 lgl:mt-14 w-full h-auto border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10">
          <ResumeCard
            title="SEO & Performance Optimization - The Shade Shop"
            subTitle="Ecommerce Platform Enhancement (2025)"
            result="100% SEO Score"
            des="Optimized SEO and performance for The Shade Shop, achieving perfect 100 SEO score and faster load times. Migrated 3,500+ images to WebP with alt text. Integrated lazy loading and refined theme architecture for better indexing."
          />
          <ResumeCard
            title="Shopify Plus Migration – Aran Woollen Mills"
            subTitle="D2C Launch & Full-Funnel Marketing Strategy (2024)"
            result="1,300+ Orders"
            des="Transformed Ireland's largest knitwear brand from wholesale B2B to premium D2C. Generated 1,300+ orders in first 3 months, 5M Meta impressions, 73k+ product views, and Google Ads ROAS of 4.56. Built comprehensive Klaviyo email automation and Shopify Plus storefront."
          />
          <ResumeCard
            title="Loyalty Program & Email Marketing – P&Co"
            subTitle="Customer Retention Strategy Implementation (2024)"
            result="28% Conv. Increase"
            des="Designed and launched tiered loyalty program with Klaviyo automation for 460k+ follower brand. Achieved 18,347 customer enrollments, 5M+ points earned, 13% AOV increase, and 28% year-over-year conversion improvement across UK and US stores."
          />
          <ResumeCard
            title="Custom Product Builder – Equiport"
            subTitle="Shopify Plus Migration with Complex Configurations (2024)"
            result="17 Options"
            des="Developed bespoke product builder handling 17+ customization options for premium equestrian supplies. Created meta-object system supporting thousands of product combinations, seamless data migration, and international tax compliance on Shopify Plus."
          />
          <ResumeCard
            title="Award-Winning Website – Dancing Leopard"
            subTitle="Shopify Plus Development & Performance Optimization (2023)"
            result="Best Website Award"
            des="Built Shopify Plus storefront with 96 desktop/73 mobile PageSpeed scores. Won 'Best Website' at Drapers Digital Awards. Implemented internationalization, mega navigation, and video integration for Black Friday readiness."
          />
        </div>
      </div>
      <div className="w-full lg:w-1/2">
        <div className="py-6 lgl:py-12 font-titleFont flex flex-col gap-4">
          <p className="text-sm font-bold text-designColor tracking-[4px]">2017 - 2025</p>
          <h2 className="text-3xl md:text-4xl font-bold">Professional Milestones</h2>
        </div>
        <div className="mt-6 lgl:mt-14 w-full h-auto border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10">
          <ResumeCard
            title="Ecommerce Platform Optimization & Management System Development"
            subTitle="The Shade Shop - E-Commerce Full Stack Lead Developer (Oct 2025-Present)"
            result="Top SEO Score & Custom Backend"
            des="Optimized SEO and performance for The Shade Shop, achieving perfect 100 SEO score. Migrated 3,500+ images to WebP. Built custom management system replacing third-party apps, reducing costs. Implemented secure backend with role-based access and CSV exports."
          />
          <ResumeCard
            title="Shopify Plus Performance, Subscriptions & Tracking – Silky Gem"
            subTitle="Silky Gem LLC - Senior E-Commerce Lead (Jan 2026-Present)"
            result="Impact Theme & 1,500+ Images"
            des="Stabilized and enhanced the Shopify Plus storefront with Core Web Vitals work, technical SEO, and subscription reliability across Recharge, Klaviyo, and the broader app stack. Owned the Impact theme relaunch and follow-on tuning, optimized 1,500+ product and content images, and improved checkout, tracking (GA4, GTM, Reddit CAPI), and fraud-prevention flows."
          />
          <ResumeCard
            title="E-Commerce Solutions for 6+ Global Clients"
            subTitle="Cake Agency - Senior E-Commerce / CMS Developer (2024-2025)"
            result="28% Sales Increase"
            des="Delivered tailored Shopify Plus and WooCommerce solutions achieving average 28% sales conversion increases. Built headless architecture (Shopify + Next.js) improving page speed by 40%. Automated processes using Zapier, Make.com, and Pabbly."
          />
          <ResumeCard
            title="Full-Stack E-Commerce Development"
            subTitle="Freelancer - E-Commerce Developer (2025-Present)"
            result="35% Performance Gain"
            des="Developed complete e-commerce website from scratch with Python web scraping, automated product import, and real-time syncing. Achieved 35% improvement in site performance (LCP/CLS). Integrated Stripe, PayPal, and B2B workflows."
          />
          <ResumeCard
            title="Shopify Expertise"
            subTitle="Shopify Inc - Lead Developer (2022-2024)"
            result="CRO Specialist"
            des="Specialized in Shopify theme development, app integrations, and payment gateways. Expert in Python web scraping, SEO optimization, and conversion rate optimization. Implemented No-Code automation workflows using multiple platforms."
          />
          <ResumeCard
            title="European Market Localization"
            subTitle="Swanky - Full Stack Developer (2020-2022)"
            result="30% Performance Boost"
            des="Customized EC-Cube, Shopify, and WordPress for European market. Integrated Konbini, PayPay, and Paidy payment systems. Built React mobile e-commerce app and achieved >30% server performance improvement using Node.js and PHP."
          />
          <ResumeCard
            title="E-Commerce Marketplace Development"
            subTitle="Nelson Technologies And Support - Frontend Developer (2017-2020)"
            result="40% Session Increase"
            des="Designed responsive e-commerce marketplace frontend using React. Built real-time analytics dashboard and customizable CMS modules. Optimized mobile/tablet UX increasing session duration by +40%. Contributed to Storybook component library."
          />
        </div>
      </div>
    </motion.div>
  );
};

export default Achievement;